import { render, staticRenderFns } from "./buttom-bar.vue?vue&type=template&id=52ae6e67&"
import script from "./buttom-bar.vue?vue&type=script&lang=js&"
export * from "./buttom-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports